import actions from './actions'

export default function ContractServicePartnerPersonsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACTSERVICEPARTNERPERSON:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTRACTSERVICEPARTNERPERSON:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACTSERVICEPARTNERPERSON:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACTSERVICEPARTNERPERSON:
      return {
        ...state,
        editing: { contractServicePartnerPersonID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_CONTRACTSERVICEPARTNERPERSON_RECIEVED:
    case actions.DELETE_CONTRACTSERVICEPARTNERPERSON_RECIEVED:
      return {
        ...state,
        editing: { contractServicePartnerPersonID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
